import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import SummaryHeader from "components/header/SummaryHeader";
import SummaryItem from "components/header/SummaryItem";
import { Inbox, Mail, MailOpen, Star } from "lucide-react";
import InboxTab from "./components/InboxTab";
import {
    getTicketList 
} from "../../../../../redux/supportticket/supportticketState";

const ClientInbox = ({
  doSearch,
  pagination,
  recordList = [],
}) => {
  const [messages, setMessages] = useState([]);
  const [starredMessages, setStarredMessages] = useState({});

  const getSenderName = (ticket) => {
    if (ticket.department && typeof ticket.department === 'string') return ticket.department;
    return "Hyvid Support"; 
  };

  useEffect(() => {
    if (recordList && recordList.length > 0) {
      const transformedMessages = recordList.map(ticket => ({
        id: ticket.tic_id,
        sender: getSenderName(ticket),
        title: ticket.tic_title || "No Subject",
        content: ticket.tic_description || "",
        isRead: ticket.ticket_status === "Resolved",
        priority: ticket.ticket_priority || "Medium Priority",
        time: ticket.created_time || "",
        date: ticket.created_date_at || "",
        attachments: [] 
      }));
      setMessages(transformedMessages);
    }
  }, [recordList]);

  useEffect(() => {
    doSearch({
      paginate: pagination.per_page,
    });
  }, [doSearch, pagination.per_page]);

  const toggleStar = (id) => {
    setStarredMessages((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const markAsRead = (message) => {
    setMessages((prev) =>
      prev.map((m) =>
        m.id === message.id ? { ...m, isRead: true } : m
      )
    );
  };

  const totalCount = messages.length;
  const unreadCount = messages.filter((m) => !m.isRead).length;
  const starredCount = Object.values(starredMessages).filter(Boolean).length;

  return (
    <div className="space-y-6">
      <SummaryHeader
        title="Communications Center"
        icon={Inbox}
        color="blue-purple"
        description="Announcements and updates from Hyvid"
      >
        <div className="summary-item-container">
          <SummaryItem
            title="Total Messages"
            icon={<Mail className="w-4 h-4" />}
            display={totalCount}
          />
          <SummaryItem
            title="Unread"
            icon={<MailOpen className="w-4 h-4" />}
            display={unreadCount}
          />
          <SummaryItem
            title="Starred"
            icon={<Star className="w-4 h-4" />}
            display={starredCount}
          />
        </div>
      </SummaryHeader>

      <InboxTab
        messages={messages}              
        starredMessages={starredMessages}  
        toggleStar={toggleStar}
        onSelectMessage={markAsRead}     
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  recordList: state.ticket.ticketList?.items,
  pagination: state.ticket.ticketList?.pagination,
  filters: state.ticket.ticketList?.filters,
});

const mapDispatchToProps = (dispatch) => ({
  doSearch: (filters) => dispatch(getTicketList(filters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ClientInbox);